// extracted by mini-css-extract-plugin
export var art = "WithdrawSuccess-module--art--4a4c9";
export var container = "WithdrawSuccess-module--container--52093";
export var done = "WithdrawSuccess-module--done--c4abc";
export var title = "WithdrawSuccess-module--title--f10a9";